var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMomo = function SvgMomo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF016C",
    fillRule: "evenodd",
    d: "M0 5.5A1.5 1.5 0 0 1 1.5 4h21A1.5 1.5 0 0 1 24 5.5v12.75a1.5 1.5 0 0 1-1.5 1.5h-21a1.5 1.5 0 0 1-1.5-1.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.625 11.25a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25m0-1.312a1.312 1.312 0 1 0 0-2.625 1.312 1.312 0 0 0 0 2.625",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.003 8.333v2.917h1.59V8.333c0-.522.099-1.06.743-1.06.848 0 .848.717.848 1.06v2.917h1.91V8.333c0-.583.119-1.06.742-1.06s.783.4.783 1.06v2.917h1.55V8.333C13.17 6.896 12.294 6 10.836 6c-.933 0-1.556.389-1.75.583C8.892 6.39 8.269 6 7.336 6 5.878 6 4.944 7.167 5.003 8.333M5.003 15.333v2.917h1.59v-2.917c0-.522.099-1.06.743-1.06.848 0 .848.717.848 1.06v2.917h1.91v-2.917c0-.583.119-1.06.742-1.06s.783.4.783 1.06v2.917h1.55v-2.917c0-1.437-.875-2.333-2.333-2.333-.933 0-1.556.389-1.75.583-.194-.194-.817-.583-1.75-.583-1.458 0-2.392 1.167-2.333 2.333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.625 18.25a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25m0-1.312a1.312 1.312 0 1 0 0-2.625 1.312 1.312 0 0 0 0 2.624",
    clipRule: "evenodd"
  })));
};
export default SvgMomo;